module.exports = __webpack_public_path__ + "img/public-nye.0f40f22e.jpg";